import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { WatchStatus } from '@/types/application/WatcherDTO';

interface CreateWatchRequest {
  watchableEntityType: string;
  watchableId: string;
  watchKind: WatchStatus;
  watchRole?: string | null;
  emailOverride?: string | null;
  userId: string;
}

interface CreateWatchResponse {
  watch: {
    id: string;
    watchableEntityType: string;
    watchableId: string;
    watchKind: WatchStatus;
    watchRole: string | null;
    emailOverride: string | null;
    userId: string;
    createdAt: string;
    updatedAt: string;
  };
}

const useCreateWatch = ({
  watchableEntityType,
  watchableId,
}: Pick<CreateWatchRequest, 'watchableEntityType' | 'watchableId'>) => {
  const queryClient = useQueryClient();

  return useMutationApi<CreateWatchRequest, CreateWatchResponse>({
    endpoint: 'core/watches',
    method: 'POST',
    options: {
      onSuccess: () => {
        // Invalidate the watchers query to refetch the data
        queryClient.invalidateQueries({
          queryKey: [`core/watches/${watchableEntityType}/${watchableId}`],
        });
      },
    },
  });
};

export default useCreateWatch;
